import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import { homeApi } from "../api/homeApi";
import { setLocalStorage } from "../../helpers/storage";

const initialState: any = {
  homeData: null,
  isOpcMember: false,
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    clearHomeData: (state) => {
      state.homeData = null;
    },
    addPostData: (state, action) => {
      const currentState = current(state);
      const isReset = action.payload?.isReset || false;
      const onTop = action.payload?.onTop || false;
      if (isReset || action.payload?.onboarding?.is_completed === false) {
        state.homeData = action.payload;
      } else {
        const currentStatePosts = currentState?.homeData?.posts || [];
        if (currentState) {
          let updatedPostArray;
          if (onTop) {
            updatedPostArray = [
              ...(action.payload?.posts || []),
              ...currentStatePosts,
            ];
          } else {
            updatedPostArray = [
              ...currentStatePosts,
              ...(action.payload?.posts || []),
            ];
          }
          state.homeData = {
            ...currentState.homeData,
            ...action.payload,
            posts: updatedPostArray,
          };
        }
      }
      // Store user data in local storage
      if (state.homeData?.user) {
        setLocalStorage("userData", JSON.stringify(state.homeData.user));
      }
      if (state.homeData?.tools_data?.fire_number) {
        setLocalStorage("fire_number", state.homeData?.tools_data?.fire_number);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      homeApi.endpoints.getHomeData.matchFulfilled,
      (state, { payload }: any) => {
        state.isOpcMember = payload?.data?.user?.memberships?.is_opc;
      },
    );
    // builder
    //   .addMatcher(homeApi.endpoints.getHomeData.matchFulfilled, (state, { payload }: any) => {
    //     let currentState: any = current(state);
    //     const currentStatePosts = currentState.homeData?.posts || [];
    //     let updatedPostArra = [...currentStatePosts, ...payload.data.posts];
    //     state.homeData = {...currentState, posts: updatedPostArra};
    //   });
  },
});

export const { clearHomeData, addPostData } = homeSlice.actions;

export default homeSlice.reducer;
